export default ({ sortBy, sortOrder }) => `${sortOrder === 1 ? '' : '-'}${sortBy}`;
